import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #161a30;

  &.values {
    font-size: 14px;
    font-weight: 600;
    color: #696f8c;
  }

  &.labels {
    font-size: 12px;
    font-weight: 400;
    color: #696f8c;
  }
`;

export const MetricDiv = styled.div`
  display: flex;
  flex-direction: Row;
  align-items: center;
  gap: 5px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const LogoDiv = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 1px solid #e6e8f0;
  background-color: #fff;
`;
